// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rec-value-picker__grid[data-v-f8c74f44]{display:grid;grid-gap:1.25rem;margin-bottom:1.25rem}@media screen and (max-width: 715px){.rec-value-picker__grid[data-v-f8c74f44]{grid-template-columns:minmax(0px, 1fr) !important}}.rec-value-picker__col[data-v-f8c74f44]{display:inline-flex;flex-direction:column}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
